import { FC } from 'react';

import { Box } from '@bonusly/design-system';

/**
 * Falling Snow Effect
 * Creates gentle snowfall animation with various snowflake emojis
 */
export const FallingSnow: FC = () => {
	// Snowflake emojis for variety
	const snowflakes = ['❄️', '❅', '❆', '✻', '✼', '✽'];

	// Generate 25 snowflakes with randomized properties
	const items = Array.from({ length: 25 }, (_, i) => {
		const snowflake = snowflakes[Math.floor(Math.random() * snowflakes.length)];
		const startX = Math.random() * 100;
		const duration = 10 + Math.random() * 15; // 10-25 seconds
		const delay = Math.random() * 20; // 0-20 second delay for stagger
		const size = 12 + Math.random() * 16; // 12-28px
		const swayAmount = 20 + Math.random() * 40; // 20-60px horizontal sway

		return {
			id: i,
			emoji: snowflake,
			startX,
			duration,
			delay,
			size,
			swayAmount,
		};
	});

	return (
		<Box position="fixed" top={0} left={0} width="100vw" height="100vh" pointerEvents="none" zIndex={9999} overflow="hidden">
			<style>
				{`
					@keyframes snowfall {
						0% {
							transform: translateY(-10vh) translateX(0) rotate(0deg);
							opacity: 0;
						}
						10% {
							opacity: 1;
						}
						90% {
							opacity: 1;
						}
						100% {
							transform: translateY(110vh) translateX(var(--sway-amount)) rotate(360deg);
							opacity: 0;
						}
					}

					.winter-snowflake {
						position: absolute;
						top: 0;
						animation: snowfall var(--duration) linear var(--delay) infinite;
						will-change: transform, opacity;
					}
				`}
			</style>
			{items.map((item) => (
				<Box
					key={item.id}
					className="winter-snowflake"
					left={`${item.startX}%`}
					fontSize={`${item.size}px`}
					style={
						{
							'--duration': `${item.duration}s`,
							'--delay': `${item.delay}s`,
							'--sway-amount': `${item.swayAmount}px`,
						} as React.CSSProperties
					}
				>
					{item.emoji}
				</Box>
			))}
		</Box>
	);
};
